import { FunctionComponent, ReactNode } from "react";
import { Box } from "@mui/material";
import { ItemPrice } from "../../../ItemPrice";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import { RemoteAirlineIcon } from "../../../RemoteAirlineIcon";

interface IAirline {
  code: string;
  name: string;
  iconOnly?: boolean;
  className?: string;
}
export const Airline = (props: IAirline) => (
  <span className={clsx("airline", props.className)}>
    <RemoteAirlineIcon airlineCode={props.code} altText={props.name} />{" "}
    {!props.iconOnly ? props.name : null}
  </span>
);

interface IPriceDisplay {
  currentPrice: string;
  discount?: string;
}
export const PriceDisplay = ({ currentPrice, discount }: IPriceDisplay) => (
  <ItemPrice current={currentPrice} discounted={discount} />
);

interface IRewardDisplay {
  reward: string;
}
export const RewardDisplay = ({ reward }: IRewardDisplay) => (
  <span className="reward">{reward}</span>
);

interface IStopSummaryProps {
  airports: string[];
  hideAirports?: boolean;
}
export const StopSummary = ({ airports, hideAirports }: IStopSummaryProps) => {
  const { t } = useI18nContext();

  return (
    <Box className="stop-summary">
      {airports.length === 0
        ? t("stopDetails.nonstop")
        : t("stopDetails.stop", { count: airports.length })}
      {airports.length > 0 && !hideAirports && (
        <span>{airports.join(", ")}</span>
      )}
    </Box>
  );
};

interface IFlightDurationProps {
  duration: string;
}
export const FlightDuration = ({ duration }: IFlightDurationProps) => {
  return <span className="duration">{duration}</span>;
};

interface IBrandNameProps {
  brandName: string;
}

export const BrandName = ({ brandName }: IBrandNameProps) => {
  return <span className="brand-name">{brandName}</span>;
};

export interface IFlightCardFieldsProps {
  children: ReactNode;
  className?: string;
}

export const FlightCardFields: FunctionComponent<IFlightCardFieldsProps> = ({
  children,
  className,
}: IFlightCardFieldsProps) => (
  <Box className={clsx("flight-card-fields", className)}>{children}</Box>
);

interface IFlightLocationsProps {
  originCode: string;
  destinationCode: string;
}
export const FlightLocations = ({
  originCode,
  destinationCode,
}: IFlightLocationsProps) => {
  return (
    <span className="locations">
      {originCode} - {destinationCode}
    </span>
  );
};
